import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StakesSection } from './components/StakesSection';
import { EdgeSection } from './components/EdgeSection';
import { ResultsSection } from './components/ResultsSection';
import { TrustedBySection } from './components/TrustedBySection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-ultra-black min-h-screen w-full overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StakesSection data-id="element-2" />
      <EdgeSection data-id="element-3" />
      <ResultsSection data-id="element-4" />
      <TrustedBySection data-id="element-5" />
      <CTASection data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}